module.exports = __webpack_public_path__ + "img/006-twitter.76c75acc.svg";